import { render, staticRenderFns } from "./HomeworkAnswerImageUpload.vue?vue&type=template&id=511bf788&"
import script from "./HomeworkAnswerImageUpload.vue?vue&type=script&lang=ts&"
export * from "./HomeworkAnswerImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports